import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import {ref, reactive, computed } from 'vue'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber, exportHandle } from '@/utils/index'
import { ElMessage, ElMessageBox } from 'element-plus'
import dayjs from 'dayjs'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { 
  'POST/house_lease_costs/year_cost': fetchList,
  // 年度工位使用情况详情
  'POST/house_lease_costs/year_seat': seatFetchList,
  // 年度成本导出
  'GET/house_lease_costs/year_export': exportApi,
} = Api

const { 
  MI_tableData, fetchData, page, size, 
  MI_total, MI_pageChange, MI_sizeChange, 
  MI_identify, MI_params, MI_modifyForm, MI_height,
} = new tbMix(fetchList)

const searchConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'date',
    props: {
      type: 'year',
      'value-format': 'YYYY-MM-DD'
    }
  },
])

let repTotalData: any = ref([])
const searchHandle = async (params: object) => {
  let repData = await fetchData(params, {}, 1);
  // repData.unassigned
  ['合计', '未分配', '总计'].map((str: string, index: number) =>{
    repData.total[index].orgName = str;

    if(index === 1){
      repData.total[1].children = repData.unassigned.map((item: any) => {
        item.orgName = item.areaOffice
        return item
      })
    }
  })
  repTotalData.value = MI_tableData.value.concat(repData.total)
}

// -------------工位-------------


const { 
  MI_tableData: setTabelData, fetchData: fetchSeatData, 
  MI_total: seatTotal, MI_identify: seatIdentify,
} = new tbMix(seatFetchList)

const seatConfig = ref([
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'date',
    props: {
      type: 'year',
      'value-format': 'YYYY-MM-DD'
    }
  },
])

let seatData: any = ref([])
const searchseatHandle = async (params: object) => {
  let repData = await fetchSeatData(params, {}, 1);
  ['合计', '未分配', '总计'].map((str: string, index: number) =>{
    repData.total[index].orgName = str;

    if(index === 1){
      repData.total[1].children = repData.unassigned.map((item: any) => {
        item.orgName = item.areaOffice
        return item
      })
    }
  })
  seatData.value = setTabelData.value.concat(repData.total)
}

const searchForm = ref()
let exportParams = computed(() => {
  if(searchForm.value && searchForm.value.dataObj.date){
    return { date: searchForm.value.dataObj.date }
  } else {

    return { date: dayjs().format('YYYY') + '-01-01'}
  }
})
/* const expCostHnalde = () => {
  ElMessageBox.confirm('请确认是否导出', '提示').then(() => {
    return exportHandle(exportApi, exportParams.value, {timeout: 0})
  }).then(() => {
    ElMessage.success('导出成功')
  })
} */


const formatSeat = (row: any, column: any, cellValue: number,) => {
  if(!cellValue) return '-';
  return cellValue.toLocaleString('zh', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_eptBtn = _resolveComponent("eptBtn")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_tabs, { type: "border-card" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_tab_pane, { label: "年度租赁成本" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
              ref_key: "searchForm",
              ref: searchForm
            }, {
                initSearch: true,
                title: true,
                searchConfig: searchConfig.value,
              }, { onSearchFn: searchHandle }), null, 16),
            _createVNode(_component_eptBtn, {
              class: "mt-5 mb-5",
              exportFn: _unref(exportApi),
              exportText: '导出年度成本',
              exportParam: _unref(exportParams)
            }, null, 8, ["exportFn", "exportParam"]),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              ref: "tb",
              border: "",
              data: _unref(repTotalData),
              "max-height": _unref(MI_height) - 70 + 'px',
              "row-key": "orgName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "组织",
                  prop: "orgName",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "1月",
                  prop: "januaryAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "2月",
                  prop: "februaryAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "3月",
                  prop: "marchAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "4月",
                  prop: "aprilAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "5月",
                  prop: "mayAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "6月",
                  prop: "juneAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "7月",
                  prop: "julyAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "8月",
                  prop: "augustAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "9月",
                  prop: "septemberAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "10月",
                  prop: "octoberAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "11月",
                  prop: "novemberAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "12月",
                  prop: "decemberAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"]),
                _createVNode(_component_el_table_column, {
                  label: "合计",
                  prop: "totalAmount",
                  align: "right",
                  formatter: _unref(formatNumber)
                }, null, 8, ["formatter"])
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(MI_identify)]
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_tab_pane, {
          label: "工位",
          lazy: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({
                initSearch: true,
                title: true,
                searchConfig: seatConfig.value,
              }, { onSearchFn: searchseatHandle }), null, 16),
            _withDirectives((_openBlock(), _createBlock(_component_el_table, {
              border: "",
              data: _unref(seatData),
              "max-height": _unref(MI_height) + 'px',
              "row-key": "orgName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: "组织",
                  prop: "orgName",
                  "show-overflow-tooltip": ""
                }),
                _createVNode(_component_el_table_column, {
                  label: "1月",
                  prop: "januarySeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "2月",
                  prop: "februarSeatt",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "3月",
                  prop: "marchSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "4月",
                  prop: "aprilSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "5月",
                  prop: "maySeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "6月",
                  prop: "juneSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "7月",
                  prop: "julySeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "8月",
                  prop: "augustSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "9月",
                  prop: "septemberSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "10月",
                  prop: "octoberSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "11月",
                  prop: "novemberSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "12月",
                  prop: "decemberSeat",
                  align: "right",
                  formatter: formatSeat
                }),
                _createVNode(_component_el_table_column, {
                  label: "合计",
                  prop: "totalSeat",
                  align: "right",
                  formatter: formatSeat
                })
              ]),
              _: 1
            }, 8, ["data", "max-height"])), [
              [_directive_loading, _unref(seatIdentify)]
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})